import { createResource } from 'redux-rest-resource'
import {
  remove,
  includes,
  map,
  get,
  cloneDeep,
  isNil,
  defaultTo,
  toNumber
} from 'lodash'
import { baseURL } from './'

export const { types, actions, rootReducer } = createResource({
  name: 'scenario',
  url: `${baseURL}`,
  credentials: 'include',
  actions: {
    fetch: {
      method: 'GET',
      gerundName: 'fetching',
      url: './scenarios/:status'
    },
    get: {
      method: 'GET',
      gerundName: 'getting',
      url: './scenarios/:id',
      assignResponse: true
    },
    getComputed: {
      method: 'GET',
      gerundName: 'getting',
      url: './scenarios/:id/calculate',
      reduce: ({ items, item, ...state }, { context, body, status }) => {
        const isFetchingItem = status === 'pending'

        // Mise Ã  jour de l'Ã©lÃ©ment
        let updatedItem = cloneDeep(item)

        if (!isFetchingItem) {
          const {
            currentVolumeInBasin,
            timeBeforeOverflow,
            currentWaterInTank,
            timeWaterVolume,
            currentEmulsifierInTank,
            timeEmulsifierVolume,
            totalWaterVolumeConsumed,
            totalEmulsifierVolumeConsumed,
            ...computedData
          } = body

          if (!isNil(updatedItem.basin)) {
            // Rangement des valeurs dans les bons casiers
            updatedItem.basin.remainingVolume = defaultTo(
              currentVolumeInBasin,
              0
            )
            updatedItem.basin.remainingTime = defaultTo(timeBeforeOverflow, 0)
          } else {
            // Rangement des valeurs dans les bons casiers
            updatedItem.silo.basin.remainingVolume = defaultTo(
              currentVolumeInBasin,
              0
            )
            updatedItem.silo.basin.remainingTime = defaultTo(
              timeBeforeOverflow,
              0
            )
          }

          updatedItem.waterTank.remainingVolume = defaultTo(
            currentWaterInTank,
            0
          )
          updatedItem.waterTank.remainingTime = defaultTo(timeWaterVolume, 0)
          updatedItem.waterTank.consumedVolume = defaultTo(
            totalWaterVolumeConsumed,
            0
          )

          updatedItem.emulsifierTank.remainingVolume = defaultTo(
            currentEmulsifierInTank,
            0
          )
          updatedItem.emulsifierTank.remainingTime = defaultTo(
            timeEmulsifierVolume,
            0
          )
          updatedItem.emulsifierTank.consumedVolume = defaultTo(
            totalEmulsifierVolumeConsumed,
            0
          )

          updatedItem = {
            ...updatedItem,
            ...computedData
          }
        }

        // Mise Ã  jour de la liste de tous les Ã©lÃ©ments avec l'Ã©lÃ©ment Ã  jour
        const updatedItems = map(items, item =>
          get(context, 'id') === get(item, 'id') ? updatedItem : item
        )

        return {
          ...state,
          items: updatedItems,
          item: updatedItem,
          isFetchingItem
        }
      }
    },
    setComputed: {
      isPure: true,
      reduce: ({ item, ...state }, { context }) => {
        // Mise Ã  jour de l'Ã©lÃ©ment
        let updatedItem = cloneDeep(item)

        const {
          currentVolumeInBasin,
          timeBeforeOverflow,
          currentWaterInTank,
          timeWaterVolume,
          currentEmulsifierInTank,
          timeEmulsifierVolume,
          totalWaterVolumeConsumed,
          totalEmulsifierVolumeConsumed,
          ...computedData
        } = context

        if (!isNil(updatedItem.basin)) {
          // Rangement des valeurs dans les bons casiers
          updatedItem.basin.remainingVolume = defaultTo(currentVolumeInBasin, 0)
          updatedItem.basin.remainingTime = defaultTo(timeBeforeOverflow, 0)
        } else {
          // Rangement des valeurs dans les bons casiers
          updatedItem.silo.basin.remainingVolume = defaultTo(
            currentVolumeInBasin,
            0
          )
          updatedItem.silo.basin.remainingTime = defaultTo(
            timeBeforeOverflow,
            0
          )
        }

        updatedItem.waterTank.remainingVolume = defaultTo(currentWaterInTank, 0)
        updatedItem.waterTank.remainingTime = defaultTo(timeWaterVolume, 0)
        updatedItem.waterTank.consumedVolume = defaultTo(
          totalWaterVolumeConsumed,
          0
        )

        updatedItem.emulsifierTank.remainingVolume = defaultTo(
          currentEmulsifierInTank,
          0
        )
        updatedItem.emulsifierTank.remainingTime = defaultTo(
          timeEmulsifierVolume,
          0
        )
        updatedItem.emulsifierTank.consumedVolume = defaultTo(
          totalEmulsifierVolumeConsumed,
          0
        )

        updatedItem = {
          ...updatedItem,
          ...computedData
        }

        return {
          ...state,
          item: updatedItem
        }
      }
    },
    update: {
      method: 'PUT',
      gerundName: 'updating',
      url: './scenarios/:id',
      assignResponse: true,
      reduce: ({ items, item, ...state }, { context, body, status }) => {
        const isUpdating = status === 'pending'

        // DonnÃ©es Ã  stocker dans le reducer
        // Lors de la mise Ã  jour stocker les donnÃ©es sources
        // Sinon stocker les donnÃ©es reÃ§ues par le serveur
        const updated = isUpdating ? context : body

        // Mise Ã  jour de l'Ã©lÃ©ment
        const updatedItem =
          get(updated, 'id') === get(item, 'id')
            ? isUpdating
              ? { ...item, ...updated }
              : updated
            : item

        // Mise Ã  jour de la liste de tous les Ã©lÃ©ments avec l'Ã©lÃ©ment Ã  jour
        const updatedItems = map(items, item =>
          get(updated, 'id') === get(item, 'id') ? updatedItem : item
        )

        return { ...state, items: updatedItems, item: updatedItem, isUpdating }
      }
    },
    create: { method: 'POST', gerundName: 'creating', url: './scenarios' },
    archive: {
      method: 'PATCH',
      gerundName: 'archiving',
      url: './scenarios/:id/archive',
      reduce: ({ items, ...state }, { body: archived }) => {
        // Suppression des donnÃ©es archivÃ©es du store
        remove(items, { id: get(archived, 'id') })

        return { ...state, items: cloneDeep(items) }
      }
    },
    archiveMany: {
      isArray: true,
      alias: 'archive',
      method: 'PATCH',
      gerundName: 'archiving',
      url: './scenarios/archive',
      reduce: ({ items, ...state }, { body: archived }) => {
        // Suppression des donnÃ©es archivÃ©es du store
        remove(items, ({ id }) => includes(map(archived, 'id'), id))

        return { ...state, items: cloneDeep(items) }
      }
    },
    close: {
      method: 'PATCH',
      gerundName: 'closing',
      url: './scenarios/:id/end',
      assignResponse: true,
      reduce: ({ items, ...state }, { body: closed }) => {
        // Suppression des donnÃ©es archivÃ©es du store
        remove(items, { id: get(closed, 'id') })

        return { ...state, items: cloneDeep(items) }
      }
    },
    closeMany: {
      isArray: true,
      alias: 'close',
      method: 'PATCH',
      gerundName: 'closing',
      url: './scenarios/end',
      assignResponse: true,
      reduce: ({ items, ...state }, { body: closed }) => {
        // Suppression des donnÃ©es archivÃ©es du store
        remove(items, ({ id }) => includes(map(closed, 'id'), id))

        return { ...state, items: cloneDeep(items) }
      }
    },
    delete: {
      method: 'DELETE',
      gerundName: 'deleting',
      url: './:id',
      reduce: ({ items, ...state }, { context: deletedItem, status }) => {
        if (status === 'resolved') {
          // Suppression des donnÃ©es archivÃ©es du store
          remove(items, {
            id: defaultTo(get(deletedItem, 'id'), toNumber(deletedItem))
          })
        }

        return { ...state, items: cloneDeep(items) }
      }
    },
    deleteMany: {
      isArray: true,
      alias: 'delete',
      method: 'DELETE',
      gerundName: 'deleting',
      url: './scenarios/delete',
      reduce: ({ items, ...state }, { context: deletedItems, status }) => {
        if (status === 'resolved') {
          // Suppression des donnÃ©es archivÃ©es du store
          remove(items, ({ id }) =>
            includes(
              map(deletedItems, deletedItem =>
                defaultTo(get(deletedItem, 'id'), toNumber(deletedItem))
              ),
              toNumber(id)
            )
          )
        }

        return { ...state, items: cloneDeep(items) }
      }
    }
  }
})
